import { render, staticRenderFns } from "./Betalok.vue?vue&type=template&id=38b59631&scoped=true"
import script from "./Betalok.vue?vue&type=script&lang=js"
export * from "./Betalok.vue?vue&type=script&lang=js"
import style0 from "./Betalok.vue?vue&type=style&index=0&id=38b59631&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b59631",
  null
  
)

export default component.exports